"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setupConfig = setupConfig;
exports.update = update;
exports.default = void 0;

var _runtimeDeferred = require("./runtimeDeferred");

var _shared = require("@exc/shared");

var _Messenger = require("./Messenger");

/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
let config = {};
const configProxy = {
  clear: (key, cb) => {
    if (key) {
      delete config[key];
      cb && _Messenger.messenger.setCallback(cb, null);
      return;
    }

    config = {};
  },
  config: () => config,
  get: key => {
    if (key.includes('/')) {
      const nestedKeys = key.split('/');
      const rollupObject = nestedKeys[0];
      const apiName = nestedKeys[1];
      return config[rollupObject] && config[rollupObject][apiName];
    }

    return config[key];
  },
  set: updates => {
    _runtimeDeferred.engine.deprecationWarnings(updates, false);

    for (let updateKey in updates) {
      if (updateKey.includes('/')) {
        const nestedKeys = updateKey.split('/');
        const rollupObject = nestedKeys[0];
        const apiName = nestedKeys[1];
        config = { ...config,
          [rollupObject]: { ...config[rollupObject],
            [apiName]: updates[updateKey]
          }
        };
      }
    }

    _Messenger.messenger.send(_shared.Events.SHELL_SETTINGS, updates);

    Object.assign(config, updates);
  }
};

function setupConfig(obj, keys, setCallback, rollupObject) {
  keys.forEach(apiName => {
    Object.defineProperty(obj, apiName, {
      get: () => {
        // Remove rollupObject argument and if statements once 'sidebar' api
        // can be fully removed since this is now handled in the configProxy set and get
        if (rollupObject) {
          const object = configProxy.get(rollupObject);
          return object[apiName];
        }

        return configProxy.get(apiName);
      },
      set: value => {
        setCallback && setCallback(apiName, value);

        if (rollupObject) {
          configProxy.set({
            [rollupObject]: {
              [apiName]: value
            }
          });
          return;
        }

        configProxy.set({
          [apiName]: value
        });
      }
    });
  });
}

function update(key, value, callbackName, forceReset) {
  let newValue = Object.assign({}, value);
  let cb = newValue.callback;

  if (cb || forceReset) {
    delete newValue.callback;

    _Messenger.messenger.setCallback(callbackName, cb);
  }

  let current = configProxy.get(key) || {};
  configProxy.set({
    [key]: Object.assign(current, newValue)
  });
}

var _default = configProxy;
exports.default = _default;